import { render } from "./CommercialInfo.vue?vue&type=template&id=4518ae35&scoped=true"
import script from "./CommercialInfo.vue?vue&type=script&lang=js"
export * from "./CommercialInfo.vue?vue&type=script&lang=js"

import "./CommercialInfo.vue?vue&type=style&index=0&id=4518ae35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4518ae35"]])

export default __exports__